import React, { FC, useMemo } from 'react';

import ToggleInput from '../../../../../../components/inputs/toggleInput';
import AampeTooltip from '../../../../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';
import ICONS from '../../../../../../constants/icons';

interface FieldToggleProps {
    isActive: boolean;
    setFieldValue: (field: string, value: boolean) => void;
    fieldKey: string;
    platform: string;
}
const FieldToggle: FC<FieldToggleProps> = ({
    isActive,
    setFieldValue,
    fieldKey,
    platform,
}) => {
    const toggleTitle = useMemo<string>(
        () =>
            isActive
                ? `Careful! On disabling, you’ll lose any ${platform} buttons you’ve already configured.`
                : `Enable  ${platform}  buttons.`,
        [isActive, platform],
    );
    const infoIconTitle = useMemo<string>(
        () =>
            `${platform} action buttons appear on your notification one below the other, so that users can interact with your message without needing to open the app.`,
        [platform],
    );
    return (
        <Container>
            <Content>
                <Title>
                    {platform} buttons {isActive ? ' enabled' : ' disabled'}{' '}
                </Title>{' '}
                <AampeTooltip placement="top" arrow title={infoIconTitle}>
                    <IconContainer>
                        <ICONS.info
                            size={20}
                            color={aampeTheme.colors.textAccessibleWG01}
                        />
                    </IconContainer>
                </AampeTooltip>{' '}
            </Content>
            <AampeTooltip title={toggleTitle} arrow placement="top">
                <div>
                    <ToggleInput
                        isActive={isActive}
                        toggleIsActive={() =>
                            setFieldValue(fieldKey, !isActive)
                        }
                        isLoading={false}
                        isError={false}
                        disabled={false}
                    />
                </div>
            </AampeTooltip>
        </Container>
    );
};
const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});
const Content = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
});

const Title = styled.div({
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.medium,
    lineHeight: aampeTheme.size.lineHeight.default,
    color: aampeTheme.colors.neutral09,
});

const IconContainer = styled.div({
    width: '20px',
    height: '20px',
    display: 'flex',
});
export default FieldToggle;
